import { Component } from '../../../../component-decorator';
import { ModalEnderecoColetaController } from '../../modal/endereco-coleta/modal-endereco-coleta.controller';

@Component({
  componentName: 'appColetaEndereco',
  template: require('./coleta-endereco.component.html'),
  bindings: {
    endereco: '<',
    codigoSituacao: '<',
    onEnderecoAtualizado: '<',
    onError: '<',
    pedidoId: '<',
  },
})
export class ColetaEnderecoComponent implements angular.IController {
  public onEnderecoAtualizado: (novoEndereco: any) => void;
  public onError: (message: any) => void;
  public endereco;
  public pedidoId;
  public user;

  public line1: string;
  public line2: string;

  constructor(private $uibModal, localStorageService) {
    'ngInject';

    this.user = localStorageService.get('user');
  }

  $onInit() {
    this.line1 = [this.endereco.logradouro, this.endereco.numero, this.endereco.complemento].filter(x => !!x).join(', ');
    const estado = /^\d+$/.test(this.endereco.uf) ? '' : this.endereco.uf;
    this.line2 = [this.endereco.bairro, this.endereco.cep, this.endereco.cidade, estado].filter(x => !!x).join(' - ');
  }

  async abrirModalEnderecoColeta() {
    try {
      const data = await this.$uibModal.open({
        animation: false,
        template: require('../../modal/endereco-coleta/modal-endereco-coleta.html'),
        controller: ModalEnderecoColetaController,
        windowClass: 'endereco-coleta',
        resolve: {
          endereco: () => this.endereco,
          enderecos: () => this.user.enderecos,
          pedidoId: () => this.pedidoId,
        }
      }).result;

      this.onEnderecoAtualizado(data.endereco);
    } catch (err) {
      if (err.message) {
        this.onError(err.message);
      }
    }
  }
}
